import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import Company from "../../../classes/Company";

export default {
  routes: [
    {
      name: "companies",
      path: "companies/:filter?",
      meta: {
        auth: () => Company.canBeViewedBy(store.state.main.user),
        icon: "company",
        title: i18n.global.tc("Company", 100),
        crumbs: ["accounting"],
        color: "primary",
      },
      component: () => import("pages/admin/Companies"),
    },
    {
      name: "companies-search",
      path: "companies/search/:query?",
      meta: {
        auth: () => Company.canBeViewedBy(store.state.main.user),
        icon: "company",
        title: i18n.global.tc("Company", 100),
      },
      component: () => import("pages/admin/Companies"),
    },
  ],

  dialogs: [
    {
      name: "vendor-company-new",
      path: "/admin/companies/vendors/new",
      meta: {
        auth: () => Company.canBeCreatedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/CompanyEdit"),
    },
    {
      name: "customer-company-new",
      path: "/admin/companies/customers/new",
      meta: {
        auth: () => Company.canBeCreatedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/CompanyEdit"),
    },
    // Any employee asking for a customer company account, made from the
    // company contact :companyID (Send Quote), or changing their request
    {
      name: "customer-company-request",
      path: "/companies/request/:companyID",
      meta: {
        auth: () => Company.canBeRequestedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/CompanyEdit"),
    },
    {
      name: "vendor-company-edit",
      path: "/admin/companies/vendors/:companyID/edit",
      meta: {
        auth: () => Company.canBeCreatedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/CompanyEdit"),
    },
    {
      name: "customer-company-edit",
      path: "/admin/companies/customers/:companyID/edit",
      meta: {
        auth: () => Company.canBeCreatedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/CompanyEdit"),
    },
    {
      name: "vendor-company-view",
      path: "/admin/companies/vendors/:companyID/view/:section",
      meta: {
        auth: () => Company.canBeViewedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/CompanyView"),
    },
    {
      name: "customer-company-view",
      path: "/admin/companies/customers/:companyID/view/:section",
      meta: {
        auth: () => Company.canBeViewedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/CompanyView"),
    },
  ],
};
